import { render, staticRenderFns } from "./AccessPointGroups.vue?vue&type=template&id=03955bd2&"
import script from "./AccessPointGroups.vue?vue&type=script&lang=js&"
export * from "./AccessPointGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports